"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScannerDetailsToJSON = exports.ScannerDetailsFromJSONTyped = exports.ScannerDetailsFromJSON = exports.instanceOfScannerDetails = exports.ScannerDetailsTypeEnum = void 0;
var PortBlockRule_1 = require("./PortBlockRule");
var ScannerConnectionStatus_1 = require("./ScannerConnectionStatus");
var ScannerHostIdentificationScanningIntensity_1 = require("./ScannerHostIdentificationScanningIntensity");
var ScannerPropertiesErrorCode_1 = require("./ScannerPropertiesErrorCode");
var ScannerSetting_1 = require("./ScannerSetting");
var ScannerStatus_1 = require("./ScannerStatus");
/**
 * @export
 */
exports.ScannerDetailsTypeEnum = {
    Physical: 'physical',
    Virtual: 'virtual'
};
/**
 * Check if a given object implements the ScannerDetails interface.
 */
function instanceOfScannerDetails(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "deploymentID" in value;
    isInstance = isInstance && "ip" in value;
    isInstance = isInstance && "netmask" in value;
    isInstance = isInstance && "connectionStatus" in value;
    isInstance = isInstance && "scannerStatus" in value;
    isInstance = isInstance && "denyList" in value;
    isInstance = isInstance && "dnsServers" in value;
    isInstance = isInstance && "settings" in value;
    isInstance = isInstance && "serialNumber" in value;
    isInstance = isInstance && "hostIdentificationScanIntensity" in value;
    isInstance = isInstance && "hostIdentificationScanPeriod" in value;
    isInstance = isInstance && "maxConcurrentVulnerabilityScans" in value;
    isInstance = isInstance && "capabilities" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "version" in value;
    isInstance = isInstance && "portBlockRules" in value;
    isInstance = isInstance && "lastOpenVASScanTimestamp" in value;
    isInstance = isInstance && "gateway" in value;
    isInstance = isInstance && "errorCode" in value;
    return isInstance;
}
exports.instanceOfScannerDetails = instanceOfScannerDetails;
function ScannerDetailsFromJSON(json) {
    return ScannerDetailsFromJSONTyped(json, false);
}
exports.ScannerDetailsFromJSON = ScannerDetailsFromJSON;
function ScannerDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'deploymentID': json['deploymentID'],
        'ip': json['ip'],
        'netmask': json['netmask'],
        'connectionStatus': (0, ScannerConnectionStatus_1.ScannerConnectionStatusFromJSON)(json['connectionStatus']),
        'scannerStatus': (0, ScannerStatus_1.ScannerStatusFromJSON)(json['scannerStatus']),
        'denyList': json['denyList'],
        'dnsServers': json['dnsServers'],
        'settings': (json['settings'].map(ScannerSetting_1.ScannerSettingFromJSON)),
        'serialNumber': json['serialNumber'],
        'hostIdentificationScanIntensity': (0, ScannerHostIdentificationScanningIntensity_1.ScannerHostIdentificationScanningIntensityFromJSON)(json['hostIdentificationScanIntensity']),
        'hostIdentificationScanPeriod': json['hostIdentificationScanPeriod'],
        'maxConcurrentVulnerabilityScans': json['maxConcurrentVulnerabilityScans'],
        'capabilities': json['capabilities'],
        'name': json['name'],
        'type': json['type'],
        'version': json['version'],
        'portBlockRules': (json['portBlockRules'].map(PortBlockRule_1.PortBlockRuleFromJSON)),
        'lastOpenVASScanTimestamp': json['lastOpenVASScanTimestamp'],
        'gateway': json['gateway'],
        'errorCode': (0, ScannerPropertiesErrorCode_1.ScannerPropertiesErrorCodeFromJSON)(json['errorCode']),
    };
}
exports.ScannerDetailsFromJSONTyped = ScannerDetailsFromJSONTyped;
function ScannerDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'deploymentID': value.deploymentID,
        'ip': value.ip,
        'netmask': value.netmask,
        'connectionStatus': (0, ScannerConnectionStatus_1.ScannerConnectionStatusToJSON)(value.connectionStatus),
        'scannerStatus': (0, ScannerStatus_1.ScannerStatusToJSON)(value.scannerStatus),
        'denyList': value.denyList,
        'dnsServers': value.dnsServers,
        'settings': (value.settings.map(ScannerSetting_1.ScannerSettingToJSON)),
        'serialNumber': value.serialNumber,
        'hostIdentificationScanIntensity': (0, ScannerHostIdentificationScanningIntensity_1.ScannerHostIdentificationScanningIntensityToJSON)(value.hostIdentificationScanIntensity),
        'hostIdentificationScanPeriod': value.hostIdentificationScanPeriod,
        'maxConcurrentVulnerabilityScans': value.maxConcurrentVulnerabilityScans,
        'capabilities': value.capabilities,
        'name': value.name,
        'type': value.type,
        'version': value.version,
        'portBlockRules': (value.portBlockRules.map(PortBlockRule_1.PortBlockRuleToJSON)),
        'lastOpenVASScanTimestamp': value.lastOpenVASScanTimestamp,
        'gateway': value.gateway,
        'errorCode': (0, ScannerPropertiesErrorCode_1.ScannerPropertiesErrorCodeToJSON)(value.errorCode),
    };
}
exports.ScannerDetailsToJSON = ScannerDetailsToJSON;
